
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class StringsTheoryEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const lines = Math.floor(30 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < lines; i++) {
                ctx.save();
                ctx.globalAlpha *= 0.3 / (layerIndex + 1);
                ctx.lineWidth = 1 * scale;
                ctx.beginPath();
                ctx.moveTo(-width * 2, (i - lines / 2) * 50 * scale);
                for (let x = -width * 2; x <= width * 2; x += 10) {
                    const y = (i - lines / 2) * 50 * scale + Math.sin(x * 0.01 + curTime + i) * 100 * scale * Math.sin(curTime * 0.5 + i);
                    ctx.lineTo(x, y);
                }
                ctx.stroke();
                ctx.restore();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
